import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Icon from 'components/Icon'

export default function Submit({onClick, className, name, value, disabled, children}) {
  const classNames = classnames('wizard_step_done', className)

  return (
    <button
      type='submit'
      name={name}
      value={value}
      className={classNames}
      disabled={disabled}
      onClick={disabled ? null : onClick}
    >
      <span className='wizard_step_tick'>
        <Icon className='wizard_step_tick_icon' name='tick' width='13px' height='9px' />
      </span>
      {children}
    </button>
  )
}

Submit.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./client/components/Wizard/Submit.js